import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { Constants } from 'src/app/constants/constants';
import { ApiService } from 'src/app/service/api.service';
import { SupportApiService } from 'src/app/service/support-api.service';
import { UtilService } from 'src/app/service/util.service';
import { ToastService } from 'src/app/service/toast.service';

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.scss']
})
export class TicketDetailComponent implements OnInit, OnDestroy {

  accountCategory: string;
  accountType: string;
  assignedTo: string;
  comment: string = null;
  requestAttachment: File = null;

  loggedInUser: any = {};
  loggedInUserRole: string;
  comments: Array<any> = new Array();
  requestAttachments: Array<any> = new Array();

  ticket: any;

  serviceDesk;
  supportUserId: string;
  statusColor: string;

  validFiles: Array<string> = ["png", "jpg", "jpeg", "pdf", "txt", "json"];
  @ViewChild('addAttachmentInput') addAttachmentInput:ElementRef;

  constructor(private apiService: ApiService, private supportApiService: SupportApiService, private route: ActivatedRoute, private authService: AuthenticationService, public utilService: UtilService, private toast: ToastService) {
    this.route.queryParamMap.subscribe(queryParams => {
      this.supportUserId = queryParams.get("supportUserId");
      this.serviceDesk = queryParams.get("serviceDesk");
      this.statusColor = queryParams.get("statusColor");
      var ticketIndex = queryParams.get("ticketIndex");
      this.getTicketForId(ticketIndex);
    });
  }

  public ngOnDestroy() {
    this.supportApiService.setSupportTickets([]);
  }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.loggedInUser = this.authService.loggedInUser;
  }

  getTicketForId(ticketId: string) {
    if(ticketId == null || ticketId == undefined) return;
    var tickets = this.supportApiService.getSupportTickets();
    this.ticket = tickets[Number(ticketId)];
    console.log("Selected ticket::", this.ticket);
    this.getRequestComments();
  }

  addSupportComment(payload: any) {
    this.utilService.showSpinner();
    this.supportApiService.addCommentRequest(this.supportUserId, this.ticket.issueId, payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("add support comment response data::", data);
      this.toast.showSuccess("Comment added successfully.");
      this.getRequestComments();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addSupportComment(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getRequestComments() {
    this.utilService.showSpinner();
    this.supportApiService.getRequestComments(this.supportUserId, this.ticket.issueId).then((data) => {
      this.utilService.hideSpinner();
      console.log("get support comments response data::", data.values);
      this.comments = data.values;
      // this.parseRequestComments(data.values);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getRequestComments();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  parseRequestComments(comments:[]) {
    this.comments = comments;
    if (comments && comments.length > 0) {
      for (var i=0; i < comments.length; i++) {
          // substringIndex = comments[i].indexOf(substring);
          // console.log(string.indexOf(substring) !== -1);
      }
    }
  }

  downloadAttachment(attachmentUrl: string, mimeType: string, filename: string) {
    console.log("attachment mime type::", mimeType);
    this.utilService.showSpinner();
    this.supportApiService.downloadAttachment(this.supportUserId, attachmentUrl).then((data) => {
      this.prepareToDownload(data, mimeType, filename);
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.downloadAttachment(attachmentUrl, mimeType, filename);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareToDownload(data, mimeType, filename: string) {
    var blob = new Blob([data], {type: mimeType});

    var downloadURL = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = filename;
    link.click();
  }

  onSubmitComment() {
    if (this.comment == null || this.comment == undefined || this.comment.trim().length == 0) return;
    if(this.requestAttachment != null && this.requestAttachment != undefined) {
      this.addAttachment(this.ticket.issueId);
    } else {
      this.addSupportComment({
        "body": this.comment,
        "public": true
      });
    }
    this.comment = null;
  }

  onAttachmentSelected(files: FileList) {
    this.requestAttachment = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      if (this.isAllowedFile(file.name)) {
        var fileSizeInMB = file.size / 1024 / 1024;
        console.log("actual file size : ", file.size, " - fileSizeInKB : ", fileSizeInMB, " - max file size limit in MB : ", Constants.SUPPORT_FILE_MAX_SIZE_MB);
        if (fileSizeInMB > 0 && fileSizeInMB < Constants.SUPPORT_FILE_MAX_SIZE_MB) {
          this.requestAttachment = file;
        } else {
          if (fileSizeInMB > Constants.SUPPORT_FILE_MAX_SIZE_MB) {
            this.toast.showError(Constants.SUPPORT_FILE_SIZE_ERROR_MESSAGE);
            return;
          } else {
            this.toast.showError(Constants.SUPPORT_FILE_SIZE_ZERO_ERROR_MESSAGE);
          }
        }
      }
    }
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isAllowedFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (!this.validFiles.includes(extension.toLowerCase())) {
      this.toast.showError("Please select valid files only.");
      return false;
    }
    return true;
  }

  addAttachment(issueId: string) {
    let formData: FormData = new FormData();
    formData.append('file', this.requestAttachment);
    this.addAttachmentToRequest(formData, issueId);
  }

  addAttachmentToRequest(formData: FormData, issueId: string) {
    console.log("attachment file::", this.requestAttachment);
    console.log("Attachment form data::", formData);
    this.comment = this.comment != null && this.comment != undefined && this.comment.length > 0 ? this.comment : "Attachment";
    this.utilService.showSpinner();
    this.supportApiService.addAttachmentToRequest(this.supportUserId, issueId, formData, this.comment).then((data) => {
      console.log("Response from add attachment request::", data);
      this.utilService.hideSpinner();
      this.resetAttachment();
      this.getRequestComments();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addAttachmentToRequest(formData, issueId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetAttachment() {
    this.addAttachmentInput.nativeElement.value = null;
    this.requestAttachment = null;
  }

  getAttachmentIcon(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    let icon = "";
    switch (extension.toLowerCase()) {
      case "png":
      case "jpg":
      case "jpeg":
        icon = "fa fa-file-image-o fa-2x";
        break;
      case "pdf":
        icon = "fa fa-file-pdf-o fa-2x";
        break;
      case "txt":
      case "text":
        icon = "fa fa-file-text-o fa-2x";
        break;
      default:
        icon = "fa fa-file-o fa-2x";
        break;
    }

    return icon;
  }

  getAttachmentSize(size): string {
    if(size < 1000) return "1 KB";
    else if(size>=1000 && size<1000000) {
      return Math.ceil(size/1000) + " KB"
    } else {
      return Math.ceil(size/1000000) + " MB"
    }
  }

  getRequestFieldValue(requestField: string): string {
    let value = "";
    let requestFieldValues: Array<any> = this.ticket.requestFieldValues;

    if(requestFieldValues && requestFieldValues.some(field => field.fieldId == requestField)) {
      value = requestFieldValues.find(field => field.fieldId == requestField).value;
    }

    return value ? value : "";
  }

  getCommentText(item: any) {
    let comment = item.body;
    let filename = null;

    if (item.attachments && item.attachments.values && item.attachments.values.length > 0) {
      filename = item.attachments.values[0].filename;
    }

    let commentTxt;
    let separator1 = "\n\n!";
    let separator2 = "\n\n[^";
    if (filename) {
      if (comment.includes(separator1)) {
        commentTxt = comment.split(separator1)[0];
      } else if (comment.includes(separator2)) {
        commentTxt = comment.split(separator2)[0];
      }
    }
    return commentTxt ? commentTxt : comment;
  }
}
